<template>
    <div class="">
        
        <template>
            <the-header />
        </template>

        <div class="site-wrapper-reveal">
            <div class="about-banner-wrap banner-space about-us-bg position-relative">
                <div class="banner-overlay"></div>
                <div class="container">
                    <div class="row">
                        <div class="col-lg-8 ml-auto mr-auto">
                            <div class="about-banner-content text-center">
                                <h1 class="mb-15 text-white">Contact Us</h1>
                                <h5 class="font-weight--normal text-white">Proven 15 years’ track record in property management. </h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="contact-us-section-wrappaer section-space--pt_100 section-space--pb_70">
                <div class="container">
                    
                    <div class="row">
                        <div class="col-lg-10 ml-auto mr-auto"> 
                            <div class="section-title-wrap text-center">               
                                <h3 class="heading">Get In <span class="text-color-primary">Touch</span></h3>
                                <h5 class="sub-title mt-8">Our friendly staff are on standby to receive your questions and comments regarding properties to lease, rent, purchase, or manage.</h5>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-8">
                            <div class="contact-form-wrap mt-12">
                                <h6 class="sub-title mb-8">Please fill the form below, and we will get back to you in 24 to 48 hours’ time.</h6>
                                <form id="contact-form">
                                    <div class="contact-form">
                                        <div class="vx-row mb-6">
                                            <div class="vx-col sm:w-1/2 w-full">
                                                <vs-input class="w-full" v-validate="'required|min:2'" placeholder="Name" name="name" v-model="sendMessage.name" />
                                                <span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('name') }}</span>
                                            </div>
                                            <div class="vx-col sm:w-1/2 w-full">
                                                <vs-input class="w-full" v-validate="'required|email'" placeholder="Email" name="email" v-model="sendMessage.email" />
                                                <span class="text-danger text-sm" v-show="errors.has('email')">{{ errors.first('email') }}</span>
                                            </div>
                                        </div>
                                        <div class="vx-row mb-6">
                                            <div class="vx-col w-full">
                                                <vs-input class="w-full" v-validate="'required|min:10|max:10'" placeholder="Phone" name="phone" v-model="sendMessage.phone" />
                                                <span class="text-danger text-sm" v-show="errors.has('phone')">{{ errors.first('phone') }}</span>
                                            </div>                   
                                        </div>
                                        <div class="vx-row mb-6 mt-8">                 
                                            <div class="vx-col w-full">
                                                <v-select class="w-full" v-validate="'required'" placeholder="Type of Inquiry" name="type of inquiry" :reduce="item => item.value" :clearable="false" :options="typeofInquiry" v-model="sendMessage.inquiry" />
                                                <span class="text-danger text-sm" v-show="errors.has('type of inquiry')">{{ errors.first('type of inquiry') }}</span>
                                            </div>
                                        </div>
                                        <div class="vx-row mb-6">
                                            <div class="vx-col w-full">
                                                <vs-textarea class="w-full mb-0" v-validate="'required'" placeholder="Comment" name="comment" v-model="sendMessage.message" />
                                                <span class="text-danger text-sm" v-show="errors.has('comment')">{{ errors.first('comment') }}</span>
                                            </div>
                                        </div>
                                        <label for="robot" class="col-sm-2 col-form-label"></label>
                                         <vue-recaptcha ref="recaptcha"
                                            @verify="onVerify" sitekey="6Lf2IvEZAAAAAMtRTFFDiYquwQvlEjBgfnxr9E0G">
                                            </vue-recaptcha>
                                        <div class="vx-row mb-6">
                                            <div class="vx-col w-full submit-btn">
                                                <vs-button type="filled" @click.prevent="submitForm" class="">Send Message</vs-button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>                    
                        <div class="col-lg-3 ml-auto">
                            <div class="conact-info-wrap mt-40">
                                <h5 class="heading mb-6">Address</h5>
                                <ul class="conact-info__list">
                                    <li>134 Enchanted Pkwy Suite 201, Manchester, MO 63021</li>
                                    <li><a href="mailto:info@axisrealtygroup.org" class="hover-style-link text-color-primary">info@axisrealtygroup.org</a></li>
                                    <li><a href="tel:+3144745277" class="hover-style-link text-black font-weight--bold">(314) 474 5277</a></li>
                                </ul>
                            </div>                        
                        </div>
                    </div>
                </div>
            </div>

            <div id="location" class="full-wrap-map">                
                <div class="google-map">
                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3118.512904802938!2d-90.50349888433155!3d38.591063372547!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x87d8d3b8dc65ad9d%3A0x4522d71c4cf8cfd2!2s134%20Enchanted%20Pkwy%20%23201%2C%20Manchester%2C%20MO%2063021%2C%20USA!5e0!3m2!1sen!2sin!4v1606194050586!5m2!1sen!2sin" width="100%" height="450" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
                </div>
            </div>

        </div>
            
        <the-footer />
    </div>
</template>

<script>
import TheHeader   from '@/layouts/components/TheHeader.vue'
import TheFooter   from '@/layouts/components/TheFooter.vue'
import vSelect from 'vue-select'
import Contact from '@/js/password.js'
import VueRecaptcha from 'vue-recaptcha'
export default {
  name: 'sendMessage',
  components: {
    TheHeader,
    TheFooter,
    'v-select': vSelect,
    'vue-recaptcha': VueRecaptcha
  },
  data () {
    return {
      sendMessage: {
        name: '',
        email: '',
        phone: '',
        inquiry: '',
        message: ''
      },
      typeofInquiry: [
        { label: 'General Inquiry',  value: 'general inquiry' },
        { label: 'Vendor Request',  value: 'vendor request' },
        { label: 'Maintenance Request',  value: 'maintenance request' },
        { label: 'Property Availability',  value: 'property availability' },
        { label: 'Other',  value: 'other' }
      ]
    }
  },
  methods: {
    onVerify () {
    },
    submitForm () {
      this.$validator.validateAll().then(result => {
        if (result) {          
          this.$vs.loading()
          Contact.addContact(this, this.sendMessage)
          this.sendMessage = ''
        } else {
          console.log('errors', this.errors)
        }
      })
    },
    contactAdded (data) {
      this.$vs.loading.close()
      this.$vs.dialog({
        type: 'alert',
        color: 'success',
        title: 'Contact',
        text: data.return_message,
        accept: null
      })
    },
    contactNotAdded (message) {
      this.$vs.loading.close()
      this.$vs.dialog({
        type: 'alert',
        color: 'danger',
        title: 'Contact',
        text: message,
        accept: null
      })
    }
  }
}
</script>